import type { EntitlementSeverity } from "./entitlementRules";
import "./capacityNotice.css";

/**
 * Compact, inline "how much licensed capacity is left" line — shared by the
 * Nodes list and the Add-a-host modal so the same copy/severity (from
 * `nodeCapacityNotice`) appears wherever an operator would actually act on
 * it, not only on a Billing page they may never open.
 */
export function CapacityNotice({ severity, message }: { severity: EntitlementSeverity; message: string }) {
  return (
    <p className={`capacity-notice capacity-notice--${severity}`} role={severity === "danger" ? "alert" : "status"}>
      {message}
    </p>
  );
}
